<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row mt-2">
        <div class="col-12 col-md-2">
          <p class="mb-0 font-weight-bold mb-1">Select a section</p>
          <div class="mb-2">
            <a-select
              size="default"
              placeholder="Select section"
              v-model="selectedSection"
              style="width: 100%"
              @change="handleSectionChange"
            >
              <a-select-option :value="0">
                All Sections
              </a-select-option>
              <a-select-option
                v-for="classSection in classSections"
                :value="classSection.id"
                :key="classSection.id"
              >
                {{ classSection.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Student Search -->
          <div class="mb-2">
            <div class="text-right">
              <a-input-search
                placeholder="Search Students.."
                v-model="search"
                @search="searchStudents"
                @change="searchStudents"
              />
            </div>
          </div>

          <!-- Student List -->
          <template v-if="data.length">
            <p class="mb-0 font-weight-bold mb-1">Students</p>
            <a-divider />
            <!-- {{data}} -->
            <p
              :class="['mb-0']"
              v-for="student in data"
              :key="student.enrollment[0].id"
            >
              <a
                :class="[
                  'mb-0',
                  `${
                    selectedStudentId === student.enrollment[0].id
                      ? 'text-primary'
                      : ''
                  }`
                ]"
                href="javascript:0;"
                @click="handleStudentSelect(student.enrollment[0].id, student)"
              >
                {{ student.first_name }} {{ student.last_name }} ({{
                  student.student_code
                }})
              </a>
            </p>
          </template>
          <template v-if="!data.length && selectedSection">
            <NoData text="No students found" />
          </template>
        </div>
        <div class="col-md-10">
          <reports-view :data="studentData" :student="selectedStudent" />
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import NoData from '@/components/layout/NoData/index'

import ReportsView from '@/components/bosemexam/final/Report/partials/ReportsView'

export default {
  name: 'DisplayFinalClassReport',
  components: {
    NoData,
    ReportsView,
  },
  mounted: function() {
    this.getClassSections()
    this.getClassSectionStudents(false)
  },
  created() {
    this.searchStudents = debounce(this.getClassSectionStudents, 500)
  },
  data: function() {
    return {
      loading: false,
      classSections: [],
      selectedSection: 0,
      selectedStudentId: null,
      selectedStudent: {},
      studentData: null,
      search: null,
      data: [],
      current: 1,
      pageSize: 10,
      meta: {},
    }
  },
  computed: {
    classId: function() {
      return this.$route.params.classId
    },
    className: function() {
      return this.$route.params.className
    },
    sessionId: function() {
      return this.$route.params.sessionId
    },
  },
  watch: {
    selectedStudentId: function(value) {
      this.loading = true
      this.$http.get('/api/reports/student/final/' + value).then(({ data }) => {
        this.loading = false
        this.studentData = data.data
      })
    },
    data: function(value) {
      if (value.length) {
        this.selectedStudentId = value[0].enrollment[0].id
        this.selectedStudent = value[0]
      } else {
        this.selectedStudentId = null
      }
    },
  },
  methods: {
    getClassSections() {
      this.loading = true
      this.$http
        .get('/api/section/class/' + this.classId, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          this.loading = false
          if (data.data.length) {
            this.classSections = data.data
          }
        })
    },
    handleSectionChange(sectionId) {
      this.getClassSectionStudents()
    },
    handleStudentSelect(studentId, student) {
      this.selectedStudentId = studentId
      this.selectedStudent = student
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getClassSectionStudents(true)
    },
    getClassSectionStudents(isSearch) {
      this.data = []
      this.loading = true
      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http
        .get('/api/student', {
          params: {
            limit: this.pageSize,
            page: page,
            search: this.search,
            class_id: this.classId,
            section_id:
              this.selectedSection === 0 ? undefined : this.selectedSection,
            session_id: this.sessionId,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.data = data.data
          this.meta = data.meta
        })
    },
  },
}
</script>
